import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { isCommonStep } from '../../constants';
import { useByocNavigationContext } from '../../context/byoc-navigation-context';
import CustomerActions from '../../../../actions/customer';
import selectCustomer from '../../../../selectors/select-customer';

// URL journey type is the source of truth in BYOC — reconcile customer.productType when
// it drifts. Common steps have no journey type in their URL, so we skip them to avoid
// clobbering a productType carried in from elsewhere.
const useSyncCustomerProductType = () => {
  const dispatch = useDispatch();
  const { activeSlug, journeyType } = useByocNavigationContext();
  const customerProductType = useSelector(selectCustomer)?.productType;

  useEffect(() => {
    if (isCommonStep(activeSlug)) return;
    if (customerProductType === journeyType) return;

    dispatch(CustomerActions.changeProductType(journeyType));
  }, [activeSlug, customerProductType, journeyType]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useSyncCustomerProductType;
